import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CloudApiService } from './cloud-api.service';
import { environment } from '../../../environments/environment';
import { IMqttService, MqttMonitorResponse } from 'src/api/mqtt';

/**
 * Cloud mode MQTT tool. Reads through DeviceRegistry.Api, which relays to the processor over the
 * WebSocket tunnel: nothing is stored in the cloud, so every poll is a live read. The API leaves the
 * messages out (`messagesAllowed: false`) for users without the Manage devices capability.
 *
 * Provide per component and call `setDeviceId()` before use.
 */
@Injectable()
export class CloudMqttService implements IMqttService {
    private http = inject(HttpClient);
    private cloudApi = inject(CloudApiService);
    private deviceId = '';

    /** Each poll is a round trip through the tunnel, so poll less often than on the processor. */
    readonly pollIntervalMs = 2000;

    setDeviceId(deviceId: string): void {
        this.deviceId = deviceId;
    }

    monitor(captureId: string | null, after: number): Promise<MqttMonitorResponse> {
        const token = this.cloudApi.token();
        let headers = new HttpHeaders();
        if (token) headers = headers.set('Authorization', `Bearer ${token}`);
        let params = new HttpParams().set('after', after);
        if (captureId) params = params.set('captureId', captureId);

        return firstValueFrom(this.http.get<MqttMonitorResponse>(`${environment.apiBaseUrl}/devices/${encodeURIComponent(this.deviceId)}/mqtt`, { headers, params }));
    }
}
